import React, {
	ChangeEventHandler,
	MouseEventHandler,
	useContext,
} from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";

import {
	ResultsMenuCategoryContext,
	ResultsMenuStoreContext,
} from "@state/context/results";
import classnames from "classnames";

import { Checkbox } from "@components/inputs/shared";
import OfferIcons from "@components/icons/Offer";
import ResultsTournamentList from "./ResultsTournamentList";

export default observer(function ResultsCategoryItem() {
	const store = useContext(ResultsMenuStoreContext);
	const category = useContext(ResultsMenuCategoryContext);

	if (store.selectedSportObj == null) {
		return null;
	}

	const checkedState = computed(() =>
		store.getCategoryCheckedState(category)
	).get();
	const categoryButtonClasses = classnames("nav--tertiary__link", {
		"is-expanded": store.expandedCategories.has(category.id),
	});
	const labelId = `sport-${store.selectedSportId}-category-${category.id}`;

	const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
		e.stopPropagation();
		store.setExpandedCategories(category.id);
	};
	const onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
		const isToggled = store.toggleCategory(category, e.target.checked);
		if (!isToggled) {
			e.target.checked = !e.target.checked;
		}
	};

	return (
		<li className="nav--tertiary__item">
			<button
				className={categoryButtonClasses}
				type="button"
				onClick={onClick}
			>
				<span className="nav--tertiary__title">
					<span className="input--check input--check--sml">
						<Checkbox
							id={labelId}
							name={category.name}
							checked={checkedState === "all"}
							indeterminate={checkedState === "some"}
							onChange={onChange}
							title={category.name}
							className="input--check__box input--check--sml__box"
						/>
						<label
							htmlFor={labelId}
							className="input--check__label input--check--sml__label"
						/>
					</span>
					<OfferIcons
						type="category"
						sport={store.selectedSportObj.abrv}
						category={category.abrv}
						className="nav--tertiary__icon u-icon u-icon--base u-mar--right--micro"
					/>
					<span>{category.name}</span>
				</span>
				<span className="nav--tertiary__counter counter counter--base">
					{category.count}
				</span>
			</button>

			<ResultsTournamentList />
		</li>
	);
});
